import React, { forwardRef } from 'react';

import { SubmenuNavRef } from '@components/Nav/SubmenuNav';
import { useEventTracking } from '@hooks';
import { ClickTarget, click } from '@tracking';
import type { NavCurrentUser } from '@utils/backend-api/currentUser';

import SettingsSubmenuNav from './SubmenuNav/SettingsSubmenuNav';
import SettingsSubmenuNavFooter from './SubmenuNav/SettingsSubmenuNav/Footer';
import SettingsSubmenuNavItem from './SubmenuNav/SettingsSubmenuNav/NavItem';
import NavItemList from './TopNav/NavItemList';
import { SETTINGS_SUBNAV_MAIN_NAV_ITEMS } from './navItems';

interface LoggedInAvatarProps {
  currentUser: NavCurrentUser;
  settingsSubmenuClassName?: string;
  forceOpen?: boolean;
}

const LoggedInAvatar = forwardRef<SubmenuNavRef, LoggedInAvatarProps>(
  ({ currentUser, settingsSubmenuClassName, forceOpen }, ref) => {
    const { trackEvent } = useEventTracking();

    return (
      <SettingsSubmenuNav
        ref={ref}
        as="button"
        avatarUrl={currentUser.avatarUrl}
        isProSubscriber={currentUser.isProSubscriber}
        submenuClassName={settingsSubmenuClassName}
        forceOpen={forceOpen}
      >
        <NavItemList className="space-y-20">
          {SETTINGS_SUBNAV_MAIN_NAV_ITEMS(currentUser).map(({ name, ...rest }) => (
            <SettingsSubmenuNavItem
              className="hover:text-primary-magenta focus:text-primary-magenta dark:hover:text-primary-pink"
              as="link"
              key={name}
              onClickCapture={() =>
                trackEvent(click({ clickTarget: ClickTarget.SettingsMenuItem, clickText: name }))
              }
              {...rest}
            >
              {name}
            </SettingsSubmenuNavItem>
          ))}
        </NavItemList>
        <hr className="my-20" />
        <SettingsSubmenuNavFooter
          avatarUrl={currentUser.avatarUrl}
          profileCompletionPercentage={currentUser.profileCompletionPercentage}
          profileCompletionStatuses={currentUser.profileCompletionStatuses}
          username={currentUser.username}
          initialSubscribeDateStr={currentUser.initialSubscribeDateStr}
        />
      </SettingsSubmenuNav>
    );
  }
);

LoggedInAvatar.displayName = 'LoggedInAvatar';

export default LoggedInAvatar;
